import commonAct from '@/commonActionHandle.js';
import baseComponent from "@/scripts/baseComponent";
import authApi from '@/api/common/auth';
import { mapState } from "vuex";
import EventBus from "@/event/EventBus";
import { API_CALL_STATUS } from "@/constant/config";
import { EXCLUDED_IP_CREATE_STATUS, EXCLUDED_IP_MODIFY_TYPE } from "@/constant/systemManagerStatus";
import ExcludedIpModify from "../../../views/modal/systemManager/excludedIp/ExcludedIpModify.vue";
import CaretTop from "../../../views/components/Icon/CaretTop.vue";
import CaretBottom from "../../../views/components/Icon/CaretBottom.vue";
const queryString = require('query-string');

export default {

    components: {
        ExcludedIpModify,
        CaretTop,
        CaretBottom,
    },

    extends: baseComponent,

    data() {
        return {
            EXCLUDED_IP_MODIFY_TYPE: EXCLUDED_IP_MODIFY_TYPE,

            isCheckAll: false,
            listData: [],
            pagination: {
                status: 1,
                querySearch: '',
                orderBy: 'A.ID',
                directionSort: 'DESC',
                pageIndex: 1,
                pageSize: 50,
                outRowsNumber: 0,
            },

            isCreating: false,
            ip: null,
            description: null,

            modalCenterExcludedIpModify: "",
            excludedIpModifyKey: 0,
            selectedList: [],
        };
    },

    computed: {
        ...mapState({
            listStaff: state => state.staffs,
            listServicePack: state => state.common.listServicePack,
            decentralization: state => state.auth.decentralization,
        }),
    },

    created() {
        EventBus.$on("openPopup", this.openPopup);
        EventBus.$on("closePopup", this.closePopup);

        this.getData();
    },

    mounted() {

    },

    methods: {

        // IP change event
        ipChangeEvent() {
            // if (this.ip) {
            //     this.ip = this.ip.substring(this.ip.lastIndexOf("@") + 1);
            // }
        },

        // Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },

        // Open pop-up
        openPopup(param) {
            $(`#${param.type}`).modal({ backdrop: "static" });
            switch (param.type) {
                case "excluded-ip-modify":
                    this.modalCenterExcludedIpModify = "d-flex";
                    this.excludedIpModifyKey++;
                    break;
            }
            this.selectedList = param.data;
        },

        // Close pop-up
        closePopup(popup) {
            $(`#${popup}`).modal("hide");
            switch (popup) {
                case "excluded-ip-modify":
                    this.modalCenterExcludedIpModify = "";
                    break;
            }
        },

        // Selected all item
        selectedAll() {
            this.listData.forEach(element => {
                element.isChecked = this.isCheckAll;
            });
        },

        // Selected item
        selectedItem() {
            if (this.listData.filter(x => x.isChecked).length === this.listData.length) {
                this.isCheckAll = true;
            } else {
                this.isCheckAll = false;
            }
        },

        // Action
        performAction(param) {
            switch (param.action) {
                case 'refresh':
                    this.getData(this.pagination);
                    break;
                case 'copyToClipboard':
                    this.copyToClipboard(param.data.inputId, param.data.data);
                    break;
            }
        },

        // Search list
        searchList() {
            this.pagination.status = 0;
            if (this.pagination.querySearch) {
                this.pagination.querySearch = this.pagination.querySearch.substring(this.pagination.querySearch.lastIndexOf("@") + 1);
            }
            this.getData();
        },

        // Sort list
        sortList(element) {
            this.pagination.pageIndex = 1;
            this.pagination.orderBy = element;
            if (this.pagination.directionSort === 'ASC') {
                this.pagination.directionSort = 'DESC'
            } else {
                this.pagination.directionSort = 'ASC'
            }
            this.getData();
        },

        // Pagination size change
        handleSizeChange(pageSize) {
            this.pagination.pageIndex = 1;
            this.pagination.pageSize = pageSize;
            this.getData();
        },

        // Pagination page change
        handleCurrentChange(element) {
            this.pagination.pageIndex = element;
            this.getData();
        },

        //Context menu action
        contextMenuAction(command) {
            switch (command.type) {
                case "modify":
                    this.openPopup({ type: "excluded-ip-modify", data: [command.data] });
                    break;
                case "deactivate":
                    this.modifyIp(EXCLUDED_IP_MODIFY_TYPE.DEACTIVATE, [command.data]);
                    break;
                case "activate":
                    this.modifyIp(EXCLUDED_IP_MODIFY_TYPE.ACTIVATE, [command.data]);
                    break;
                case "remove":
                    this.modifyIp([command.data]);
                    break;
            }
        },

        // Get data
        getData() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            this.isCheckAll = false;
            authApi.excludedIpView(queryString.stringify(this.pagination))
                .then((res) => {
                    try {
                        let responseData = res.data;
                        let pagingItem = res.data.pagingItem;
                        responseData.data.forEach(element => {
                            element.isChecked = false;
                        });
                        this.listData = responseData.data;
                        this.pagination.orderBy = pagingItem.orderBy;
                        this.pagination.directionSort = pagingItem.directionSort;
                        this.pagination.pageIndex = pagingItem.pageIndex;
                        this.pagination.pageSize = pagingItem.pageSize;
                        this.pagination.outRowsNumber = pagingItem.outRowsNumber;

                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.listData);
                    } catch (error) {
                        console.log("getData -> error", error)
                        this.feedStatusLoading(API_CALL_STATUS.FAILED);
                    }
                })
                .catch(error => {
                    try {
                        if (error.name === 'Error') {
                            if (this.$route.path !== '/login') {
                                setTimeout(() => {
                                    // location.href = "/login";
                                }, 2000);
                            }
                        } else {
                            switch (error.errorCode) {
                                default:
                                    console.log("getData -> error", error)
                                    // this.$store.dispatch("common/showUnkownError", error, "Error");
                                    break;
                            }
                        }
                    } catch (error) {
                        console.log("getData -> error", error)
                        // this.$store.dispatch("common/showUnkownError", error, "Error");
                    }
                    this.feedStatusLoading(API_CALL_STATUS.FAILED);
                });
        },

        // Add IP
        addIp() {
            this.isCreating = true;
            let request = {
                ip: this.ip,
                description: this.description,
                deviceInformation: JSON.stringify(this.getInformationClient()),
            }
            authApi.excludedIpCreate(request)
                .then((res) => {
                    setTimeout(() => {
                        try {
                            let responseData = res.data;
                            switch (responseData) {
                                case EXCLUDED_IP_CREATE_STATUS.INSERT_SUCCESS:
                                    this.notificationSuccess(
                                        "Success !",
                                        `IP <strong>${this.ip} </strong> has been added successfully`
                                    );
                                    this.ip = null;
                                    this.description = null;
                                    this.getData();
                                    break;
                                case EXCLUDED_IP_CREATE_STATUS.ACTIVATED_SUCCESS:
                                    this.notificationSuccess(
                                        "Success !",
                                        `IP <strong>${this.ip} </strong> has been activated successfully`
                                    );
                                    this.ip = null;
                                    this.description = null;
                                    this.getData();
                                    break;
                                case EXCLUDED_IP_CREATE_STATUS.IP_ALREADY_EXISTS:
                                    this.notificationError(
                                        "Failed !",
                                        `IP <strong>${this.ip} </strong> already exists`
                                    );
                                    break;
                            }
                        } catch (error) {
                            console.log("getData -> error", error)
                        }
                        this.isCreating = false;
                    }, 500);
                })
                .catch(error => {
                    try {
                        if (error.name === 'Error') {
                            if (this.$route.path !== '/login') {
                                setTimeout(() => {
                                    location.href = "/login";
                                }, 2000);
                            }
                        } else {
                            switch (error.errorCode) {
                                default:
                                    console.log("getData -> error", error)
                                    this.$store.dispatch("common/showUnkownError", error, "Error");
                                    break;
                            }
                        }
                    } catch (error) {
                        console.log("getData -> error", error)
                        this.$store.dispatch("common/showUnkownError", error, "Error");
                    }
                    this.isCreating = false;
                });
        },

        // Modify IP
        modifyIp(type, listSelected) {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            let request = {
                listData: listSelected,
                type: type,
                deviceInformation: JSON.stringify(this.getInformationClient()),
            }
            authApi.excludedIpModify(request)
                .then((res) => {
                    try {
                        this.getData();
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    } catch (error) {
                        console.log("getData -> error", error)
                        this.feedStatusLoading(API_CALL_STATUS.FAILED);
                    }
                })
                .catch(error => {
                    try {
                        if (error.name === 'Error') {
                            if (this.$route.path !== '/login') {
                                setTimeout(() => {
                                    location.href = "/login";
                                }, 2000);
                            }
                        } else {
                            switch (error.errorCode) {
                                default:
                                    console.log("getData -> error", error)
                                    this.$store.dispatch("common/showUnkownError", error, "Error");
                                    break;
                            }
                        }
                    } catch (error) {
                        console.log("getData -> error", error)
                        this.$store.dispatch("common/showUnkownError", error, "Error");
                    }
                    this.feedStatusLoading(API_CALL_STATUS.FAILED);
                });
        },

        // Delete IP
        deleteIp(listSelected) {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            let request = {
                listData: listSelected,
                deviceInformation: JSON.stringify(this.getInformationClient()),
            }
            authApi.excludedIpDelete(request)
                .then((res) => {
                    try {
                        this.getData();
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    } catch (error) {
                        console.log("getData -> error", error)
                        this.feedStatusLoading(API_CALL_STATUS.FAILED);
                    }
                })
                .catch(error => {
                    try {
                        if (error.name === 'Error') {
                            if (this.$route.path !== '/login') {
                                setTimeout(() => {
                                    location.href = "/login";
                                }, 2000);
                            }
                        } else {
                            switch (error.errorCode) {
                                default:
                                    console.log("getData -> error", error)
                                    this.$store.dispatch("common/showUnkownError", error, "Error");
                                    break;
                            }
                        }
                    } catch (error) {
                        console.log("getData -> error", error)
                        this.$store.dispatch("common/showUnkownError", error, "Error");
                    }
                    this.feedStatusLoading(API_CALL_STATUS.FAILED);
                });
        },
    }
}